<template>
  <div class="home-page-wrapper">
    <Header />
    <ul class="home-tab">
      <li
        :class="this.selectedActive === 'allcheckinList' ? 'active' : ''"
        @click="handleActiveCheckIn('allcheckinList')"
      >
        {{$t('AllcheckIns')}}
      </li>
      <li
        :class="this.selectedActive === 'allnearbybusinessList' ? 'active' : ''"
        @click="handleActiveCheckIn('allnearbybusinessList')"
      >
        {{$t('Nearbycheckins')}}
      </li>
    </ul>
    <main class="main_Content">
      <!-- <AllCheckinBusinessList v-if="selectedActive === 'allcheckinList'" :allfeeds=true /> -->
   <AllCheckinBusinessList v-if="selectedActive === 'allcheckinList'"  />
    <AllCheckinNearByBusinessList
        v-if="selectedActive === 'allnearbybusinessList'"
      />
    <BusinessIntroModal v-if="popupClose" />
    </main>
    <div class="loader" v-if="loading">
      <img src="../assets/images/gif-loader.gif" />
    </div>
    <Footer />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
// import "../../public/scss/animation.scss";
import "../assets/scss/animation.scss";
import types from "../store/types";
import Vue from "vue";
import VueCookie from "vue-cookie";
import InfiniteLoading from "vue-infinite-loading";
import ApiCaller from "../utils/apicaller";
import axios from "axios";
import AllCheckinBusinessList from "../components/AllCheckinBusinessList";
import AllCheckinNearByBusinessList from "../components/AllCheckinNearByBusinessList";
import BusinessIntroModal from "../components/Modal/BusinessIntroModal";
import { toaster } from "../utils/helper";
Vue.use(InfiniteLoading);
Vue.use(VueCookie);

export default {
  name: "Wall",
  components: {
    Header,
    Footer,
    InfiniteLoading,
    AllCheckinBusinessList,
    AllCheckinNearByBusinessList,
    BusinessIntroModal
  },
  data() {
    return {
      likeCount: "",
      isLike: false,
      animateLike: 0,
      limit: 0,
      selectedActive: "allcheckinList",
      loading:false,
      showPopup: true,
    };
  },
  computed: {
    ...mapState(["feeds", "popupClose"])
  },
  methods: {
    changeLocale(locale) {
      if (["tl", "ta"].includes(this.$cookie.get("lang"))) {
        document.querySelector("body").classList.add("activeMultiLang");
      }
      this.$i18n.locale =
        this.$cookie.get("lang") || document.URL.split("=")[1] || "hi";
    },
    handleActiveCheckIn(data) {
      this.selectedActive = data;
    },
  },
  mounted() {
    // this.$store.dispatch({ type: "getBusiness" });
    this.changeLocale();
    // this.$store.commit(types.LOADFEEDS, []);
    // this.infiniteHandler();
    // this.$store.commit("WITHQRHEADER", true);
    // this.$store.commit("WITHQRFOOTER", true);
  }
};
</script>
<style></style>
